import * as React from "react"
import { useTranslation } from "react-i18next"
import { getFont } from "../util/Util"
import ForgotPassword from "../views/forgotpassword/ForgotPassword"
import LoginForm from "../views/auth/Login"
import ResetPassword from "../views/resetpassword/ResetPassword"
import AppProps from "../util/AppProps"
import { Redirect, Route, Router, Switch } from "react-router"
import { Layout } from "antd"
import "./style.css"
import UserProps from "../util/UserProps"
import ShadowLogin from "../views/shadowlogin/ShadowLogin"

const { Content } = Layout

const NotSecuredLayout = (props: AppProps & UserProps) => {
    const { i18n } = useTranslation("global")

    return (
        <Content className="login-content" style={getFont(i18n)}>
            <div className="login-content-red-background" />
            <div className="login-content-blue-background" />
            <div className="login-content-container">
                <div className="login-page-h1">
                    <img className='login-content-logo' src={"/images/logo_personaly_black.svg"} alt="" />
                </div>
                <div className="login-page-h2">Advertiser's Dashboard</div>
                <Router history={props.history}>
                    <Switch>
                        <Route path="/shadow-login" render={() => <ShadowLogin {...props} />} />
                        <Route path="/login" render={() => <LoginForm {...props} />} />
                        <Route path="/forgotpassword" component={ForgotPassword} />
                        <Route path="/resetpassword" component={ResetPassword} />
                        <Redirect to="/login" />
                    </Switch>
                </Router>
            </div>
        </Content>
    )
}

export default NotSecuredLayout



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/layouts/NotSecuredLayout.tsx